const sortBySelected = (items = []) => {
  return items.sort((a, b) => (b == null ? void 0 : b.selected) - (a == null ? void 0 : a.selected));
};

export default sortBySelected;